<template>
  <div class="d-block">
    <!-- filter template component -->
    <filter-template-wrapper
      v-if="useFilterTemplate"
      :filter-template="filterTemplate"
      :functional-code="props.functionalCode"
      @delete-template="deleteTemplate"
      @select-template="settingFilterTemplate"
    />
    <base-card-search
      :title="titleFilterTemplate"
      :show-action="!loading && !error"
      v-bind="baseCardSearchAttrs"
      @submit.prevent="search"
      @reset="reset"
    >
      <!-- <template v-if="customCreateData" #create-data>
        <component :is="customCreateData" />
      </template> -->
      <template #create-data="slotProps">
        <slot
          name="create-data"
          v-bind="{ ...slotProps, default_search, advanced_search }"
        ></slot>
      </template>
      <template #content>
        <div v-if="loading">
          <FilterSearchingLoading />
        </div>
        <div v-if="error">
          <span class="text-danger font-weight-bold">{{
            $t("panel.label_system_error")
          }}</span>
        </div>
        <template v-if="!loading && !error">
          <default-wrapper
            v-if="default_search.length"
            :list-default-component="default_search"
          />
          <advanced-wrapper
            v-if="listAdvFilterSearch.length"
            v-model="advanced_search"
            :list-adv-component="listAdvFilterSearch"
          />
        </template>
      </template>
    </base-card-search>
    <div class="d-block">
      <div class="d-flex w-100 justify-content-end">
        <export-progressing-bar class="w-100" :task-name="taskName" />
      </div>
    </div>
    <base-table-result
      v-if="fields.length"
      :loading="loadingSearch"
      :table-column-loading="fields.length"
      :current-page="paginate.current_page"
      :total-rows="paginate.total"
      :per-page="paginate.per_page"
      :show-pagination="paginate.last_page > 1"
      @change="changePage"
    >
      <b-table
        striped
        hover
        bordered
        table-class="text-nowrap"
        show-empty
        :items="items"
        :fields="fields"
      >
        <template #table-colgroup="scope">
          <slot name="table-colgroup-custom" v-bind="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ 'min-width': field.key == 'name' ? '150px' : '100px' }"
              :width="fields.key == 'name' ? '150px' : '100px'"
            />
          </slot>
        </template>
        <!-- open cell slot -->
        <template v-for="field in fields" #[`cell(${field.key})`]="data">
          <slot :name="`cell(${field.key})`" :data="data">
            {{ data.item[field.key] }}
          </slot>
        </template>

        <template #empty>
          <div class="d-block text-center">
            {{ $t("panel.label_no_data") }}
          </div>
        </template>
      </b-table>
    </base-table-result>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import useLoadMstFilterSearching from "@/hooks/useLoadMstFilterSearching";
import FilterSearchingLoading from "./FilterSearchingLoading.vue";
import AdvancedWrapper from "@/components/FilterSearching/Account/Advanced/AdvancedWrapper.vue";
import DefaultWrapper from "@/components/FilterSearching/Account/Default/DefaultWrapper.vue";
import ExportProgressingBar from "@/components/ExportProgressing/ExportProgressingBar.vue";
import FilterTemplateWrapper from "@/components/FilterTemplate/FilterTemplateWrapper.vue";

const props = defineProps({
  functionalCode: {
    type: String,
    default: "",
  },
  eventCmsCode: {
    type: String,
    default: "",
  },
  contentCmsCode: {
    type: String,
    default: "",
  },
  routeName: {
    type: String,
    default: "",
  },
  searchingFunction: {
    type: Function,
    default: () => () => {},
  },
  baseCardSearchAttrs: {
    type: Object,
    default: () => {},
  },
  customCreateData: {
    type: Object,
    default: null,
  },
  fields: {
    type: Array,
    default: function () {
      return [];
    },
  },
  taskName: {
    type: String,
    default: "",
  },
  extendParams: {
    type: Object,
    default: () => {},
  },
  useFilterTemplate: {
    type: Boolean,
    default: false,
  },
});

const {
  loading,
  error,
  listAdvFilterSearch,
  advanced_search,
  default_search,
  search,
  loadingSearch,
  paginate,
  items,
  changePage,
  reset,
  settingFilterTemplate,
  filterTemplate,
  deleteTemplate,
  titleFilterTemplate,
} = useLoadMstFilterSearching({
  config_searching: {
    service_function: props.searchingFunction,
    event_cms_code: props.eventCmsCode,
    content_cms_code: props.contentCmsCode,
    route_name: props.routeName,
    extend_params: props.extendParams,
    use_filter_template: props.useFilterTemplate,
  },
  functional_code: props.functionalCode,
});
</script>

<style lang="scss" scoped></style>
